export const CONSENT_WITHDRAWAL_STATUS_DECLINED: string = 'declined';
export const CONSENT_WITHDRAWAL_STATUS_RETRACTED: string = 'retracted';
export const CONSENT_WITHDRAWAL_STATUS_DATA_REMOVED: string = 'dataRemoved';